<template>
  <div class="issue-chat-history" >
    <div class="issue-chat-history__status" :style="{background: actionColor}">
      {{item.action}}
    </div>
  </div>
</template>

<script>
  export default {
    name: "HistoryItem",
    props: {
      item: {
        required: true
      }
    },
    computed: {
      actionColor(){
        return this.$store.getters['common/tasks/statusById'](this.item.status_id).color
      }
    }
  }
</script>

<style lang="scss">
.issue-chat-history{
  text-align: center;

  &__status{
    display: inline-block;
    background: rgba(var(--app-primary), 1);
    color: #fff;
    padding: 5px 10px;
    border-radius: 20px;
    margin-bottom: 5px;
  }
}
</style>
